export default [{"id":"1","startTime":0,"endTime":3721,"text":"<b>In the next step, the back panel is assembled.</b>"}];